module.exports = __webpack_public_path__ + "media/images/lb/921-daea9c3425ce5ba9cc4cda4b674a5252.svg";